<template>
  <container>
    <div class="subpage__cnt col-xl-10 offset-xl-1 text-center">
      <div class="subpage-accordion text-left">
        <div class="subpage-accordion__item"
             :class="{ active : $index === currentAccordion }"
             v-for="(accordion, $index) in accordions"
             :key="accordion.id">
          <div class="subpage-accordion__header" @click="toggle($index)">
            <div class="subpage-accordion__title">
              {{ accordion.title }}
            </div>
            <span class="subpage-accordion__caret">
                    <svg-icon type="icon-arrow-down"/>
                  </span>
          </div>
          <slide-up-down :duration="600" :active="$index === currentAccordion">
            <div class="subpage-accordion__cnt" v-html="accordion.text"></div>
          </slide-up-down>
        </div>
      </div>
    </div>
  </container>
</template>

<script>
export default {
  name: 'UniDetailCampus',
  data () {
    return {
      currentAccordion: null,
      accordions: [
        {
          id: 0,
          title: 'Sağlık',
          text: '<p> Kampüsümüzdeki mediko-sosyal ve psikolojik danışmanlık hizmeti verilmektedir. ' +
          'Sağlık Merkezi\'nde 1 diş hekimi, 3 hemşire, 1 tane laboratuvar teknisyeni, 1 acil tıp ' +
          'teknisyeni ve 1 psikolog görev yapmaktadır. <br><br> Ayrıca; A sınıfı Aile Hekimliği ' +
          'Merkezi mevcut olup 1 Aile Hekimi hizmet vermektedir. Üniversitemizin öğrenci ve personeli' +
          ' gerekli durumlarda bu merkezlerimize başvurarak, tıbbi muayene ve tedavi, diş ile ilgili ' +
          'muayene ve tedavi hizmetleri ve psikolojik danışmanlık hizmeti alabilmektedirler. <br><br> ' +
          'Ayrıca, sağlık sorunlarıyla ilgili çok sayıda tetkik yapılmaktadır. Merkezimizde acil vakalarda ' +
          'ilk müdahale yapılmakta ve gerekli durumlarda ambulans ile en yakın hastaneye nakil sağlanmaktadır. </p>',
          active: false
        },
        {
          id: 1,
          title: 'Spor',
          text: '<p> Kampüsümüzdeki mediko-sosyal ve psikolojik danışmanlık hizmeti verilmektedir. ' +
          'Sağlık Merkezi\'nde 1 diş hekimi, 3 hemşire, 1 tane laboratuvar teknisyeni, 1 acil tıp ' +
          'teknisyeni ve 1 psikolog görev yapmaktadır. <br><br> Ayrıca; A sınıfı Aile Hekimliği ' +
          'Merkezi mevcut olup 1 Aile Hekimi hizmet vermektedir. Üniversitemizin öğrenci ve personeli' +
          ' gerekli durumlarda bu merkezlerimize başvurarak, tıbbi muayene ve tedavi, diş ile ilgili ' +
          'muayene ve tedavi hizmetleri ve psikolojik danışmanlık hizmeti alabilmektedirler. <br><br> ' +
          'Ayrıca, sağlık sorunlarıyla ilgili çok sayıda tetkik yapılmaktadır. Merkezimizde acil vakalarda ' +
          'ilk müdahale yapılmakta ve gerekli durumlarda ambulans ile en yakın hastaneye nakil sağlanmaktadır. </p>',
          active: false
        },
        {
          id: 2,
          title: 'Beslenme',
          text: '<p> Kampüsümüzdeki mediko-sosyal ve psikolojik danışmanlık hizmeti verilmektedir. ' +
          'Sağlık Merkezi\'nde 1 diş hekimi, 3 hemşire, 1 tane laboratuvar teknisyeni, 1 acil tıp ' +
          'teknisyeni ve 1 psikolog görev yapmaktadır. <br><br> Ayrıca; A sınıfı Aile Hekimliği ' +
          'Merkezi mevcut olup 1 Aile Hekimi hizmet vermektedir. Üniversitemizin öğrenci ve personeli' +
          ' gerekli durumlarda bu merkezlerimize başvurarak, tıbbi muayene ve tedavi, diş ile ilgili ' +
          'muayene ve tedavi hizmetleri ve psikolojik danışmanlık hizmeti alabilmektedirler. <br><br> ' +
          'Ayrıca, sağlık sorunlarıyla ilgili çok sayıda tetkik yapılmaktadır. Merkezimizde acil vakalarda ' +
          'ilk müdahale yapılmakta ve gerekli durumlarda ambulans ile en yakın hastaneye nakil sağlanmaktadır. </p>',
          active: false
        },
        {
          id: 3,
          title: 'Aktivite Odaları',
          text: '<p> Kampüsümüzdeki mediko-sosyal ve psikolojik danışmanlık hizmeti verilmektedir. ' +
          'Sağlık Merkezi\'nde 1 diş hekimi, 3 hemşire, 1 tane laboratuvar teknisyeni, 1 acil tıp ' +
          'teknisyeni ve 1 psikolog görev yapmaktadır. <br><br> Ayrıca; A sınıfı Aile Hekimliği ' +
          'Merkezi mevcut olup 1 Aile Hekimi hizmet vermektedir. Üniversitemizin öğrenci ve personeli' +
          ' gerekli durumlarda bu merkezlerimize başvurarak, tıbbi muayene ve tedavi, diş ile ilgili ' +
          'muayene ve tedavi hizmetleri ve psikolojik danışmanlık hizmeti alabilmektedirler. <br><br> ' +
          'Ayrıca, sağlık sorunlarıyla ilgili çok sayıda tetkik yapılmaktadır. Merkezimizde acil vakalarda ' +
          'ilk müdahale yapılmakta ve gerekli durumlarda ambulans ile en yakın hastaneye nakil sağlanmaktadır. </p>',
          active: false
        }
      ]
    }
  },
  methods: {
    toggle (index) {
      if (index === this.currentAccordion) {
        this.currentAccordion = null
      } else {
        this.currentAccordion = index
      }
    }
  }
}
</script>

<style scoped>

</style>
